/*
 * Kardima mobile menu. Spec: docs/mobile-menu-spec.md.
 *
 * Open/close, scroll lock, Escape, focus handling. The accordions themselves are native
 * <details> and need no JS at all.
 *
 * The panel uses `hidden` plus a `data-open` attribute rather than a class: `hidden` keeps it
 * out of the accessibility tree while closed, and data-open drives the transform transition.
 */
(function () {
  function init() {
    var panel = document.getElementById('KardimaMobileMenu');
    var backdrop = document.querySelector('[data-kardima-menu-backdrop]');
    var openBtn = document.querySelector('[data-kardima-menu-open]');
    var closeBtn = document.querySelector('[data-kardima-menu-close]');
    if (!panel || !backdrop || !openBtn) return;

    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      panel.hidden = false;
      backdrop.hidden = false;
      // Force a reflow so the transform transition runs from its start value rather than
      // being collapsed into the same frame as `hidden` being removed.
      void panel.offsetWidth;
      panel.setAttribute('data-open', '');
      backdrop.setAttribute('data-open', '');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      panel.removeAttribute('data-open');
      backdrop.removeAttribute('data-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';

      var done = function () {
        panel.hidden = true;
        backdrop.hidden = true;
        panel.removeEventListener('transitionend', done);
      };
      // transitionend won't fire if the user has reduced motion on, so guarantee cleanup.
      panel.addEventListener('transitionend', done);
      setTimeout(done, 500);

      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && panel.hasAttribute('data-open')) close();
    });

    // Following a link should leave the menu closed behind it (matters on back-navigation,
    // where the panel would otherwise still be open with the body scroll-locked).
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a')) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
